import { _js } from '@ifixit/localize';
import { Auth } from 'Shared/auth';
import { FormManager } from 'Shared/form_manager';
import { StatusPanel } from 'Shared/status_panel';
import { Modal } from 'Shared/modal';
import { Recaptcha } from 'Shared/recaptcha';
import trackInPiwikAndGA from 'Shared/Analytics/CombinedGAPiwik';
import { setupFacebookLoginButton } from 'Shared/facebookHelper';
import { SentryError } from '@ifixit/sentry';

function LoginPanel() {
   let emailInputs = {
         showLogin: $('email'),
         showRegister: $('reg-email'),
         showPasswordReset: $('reset-email'),
      },
      _this = this;

   this.focusEmail = function () {
      let input = getEmailInput();
      if (input) {
         // We delay this till the next turn of the event loop when the UI has
         // been updated (often the panel is shown, then focus is called)
         // othwise it seems to have no affect.
         (function () {
            try {
               // This can fail on old versions of IE because they throw an error
               // if this is called when the controls are not visible yet.
               input.focus();
               // eslint-disable-next-line no-empty
            } catch {}
         }).delay(0);
      }
   };

   this.getEmail = function () {
      let input = getEmailInput();
      return input && input.value;
   };

   this.setEmails = function (email) {
      for (let cssClass in emailInputs) {
         emailInputs[cssClass].set('value', email);
      }
   };

   function getEmailInput() {
      let loginContainer = $('login');
      for (let cssClass in emailInputs) {
         if (loginContainer.hasClass(cssClass)) {
            return emailInputs[cssClass];
         }
      }
   }

   this.focusFirst = function () {
      _this.focusEmail();
   };

   this.showPanel = function (cssClass) {
      let email = _this.getEmail();
      let login = $('login');
      cssClass = cssClass || login.get('data-initial');
      ['showLogin', 'showRegister', 'showPasswordReset'].forEach(login.removeClass.bind(login));
      login.addClass(cssClass);
      _this.setEmails(email);
      _this.focusFirst();
      Modal.fireEvent('showPanel:' + cssClass);
      this.trackViewModal(cssClass);
   };

   this.destroy = function () {
      if (document.querySelector('#login').hasClass('showLogin')) {
         trackInPiwikAndGA({
            eventCategory: 'Login Popup Exit',
            eventAction: 'Login Popup Exit - Close',
         });
      }
   };

   this.trackViewModal = function (cssClass) {
      const actions = {
         showRegister: 'Register',
         showLogin: 'Login',
      };

      if (cssClass in actions) {
         const action = actions[cssClass];
         trackInPiwikAndGA({
            eventCategory: `${action} Popup View`,
            eventAction: `${action} Popup View - Open`,
         });
      }
   };

   this.showPanel();
   this.focusFirst();
}

const LoginForm = new Class({
   Implements: [Events],

   initialize: function () {
      this.formName = 'loginForm';
      this.emailName = 'email';
      this.regEmailName = 'reg-email';
      this.passwordName = 'password';
      this.codeName = 'login-code';
      this.registerForm = 'registerForm';
      this.formManager = new FormManager(this.formName);
      this.currentStep = 'email'; // email, auth, code

      // Keep track of entered email
      this.userEmail = '';
      this.codeSent = false;

      let inviteData = $('inviteData');
      if (inviteData) {
         $(this.emailName).set('value', inviteData.get('data-email'));
      }

      // Initialize password toggle for registration
      if (Browser.name === 'ie' || Browser.name === 'safari') {
         $$('.show-password').hide();
      } else {
         $$('.show-password').addEvent('click', event => {
            this.togglePassword(event);
         });
      }

      this.initializeHandlers();
      this.initializeSSO();
   },

   initializeHandlers: function () {
      // Handle email form continue button
      clickSafe('continueBtn', async event => {
         event.stop();
         const emailInput = $(this.emailName);
         const continueBtn = $('continueBtn');

         // Validate email format
         if (!emailInput.value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailInput.value)) {
            this.formManager.showError(emailInput, App.loginMessages.invalid_email);
            return;
         }

         // Disable button while validating
         if (continueBtn) {
            continueBtn.set('disabled', true);
            continueBtn.addClass('loading');
         }

         // Validate email with API
         await Auth.validateLogin(emailInput.value, response => {
            // Re-enable button
            if (continueBtn) {
               continueBtn.set('disabled', false);
               continueBtn.removeClass('loading');
            }

            if (response.hasAccount) {
               // Email exists
               this.userEmail = emailInput.value;

               if (response.ssoAssociation) {
                  // If the account is associated with an SSO provider, they don't have
                  // a password, so send them a one-time code.
                  this.handleRequestCode();
               } else {
                  // Account exists and uses password, proceed to auth step
                  this.showAuthStep();
               }
            } else {
               // Account doesn't exist
               this.formManager.showError(emailInput, App.loginMessages.invalid_email);
            }
         });
      });

      // Handle form submissions
      this.formManager.addSubmitHandler(() => {
         if (!this.loginVisible()) {
            return true;
         }

         if (this.currentStep === 'auth') {
            return this.handlePasswordSubmit();
         }

         if (this.currentStep === 'code') {
            return this.handleCodeSubmit();
         }

         return false;
      });

      // Handle request code link click
      if ($('requestCodeLink')) {
         $('requestCodeLink').addEvent('click', e => {
            e.preventDefault();
            this.handleRequestCode();
         });
      }

      // Add form toggle handling
      $$('.formToggle').addEvent('click', event => {
         if (event.target.id == 'loginFromReset' && window.onLoginPage) {
            return;
         }
         event.preventDefault();
         LoginPanelManager.showPanel(event.target.get('data-action'));
      });
   },

   loginVisible: function () {
      return $('login').hasClass('showLogin');
   },

   showAuthStep: function () {
      this.currentStep = 'auth';
      $('emailStep').hide();
      $('authStep').show();
      $('codeStep').hide();

      // Update email display
      document.querySelectorAll('.userEmailDisplay').forEach(element => {
         element.innerHTML = this.userEmail;
      });

      // Focus password input
      if ($(this.passwordName)) {
         $(this.passwordName).focus();
      }

      document.querySelector('#authStep #password').addEventListener('keydown', event => {
         if (event.key === 'Enter') {
            event.preventDefault();
            document.querySelector('#loginBtn').click();
         }
      });
   },

   showCodeStep: function () {
      this.currentStep = 'code';
      $('emailStep').hide();
      $('authStep').hide();
      $('codeStep').show();

      if ($(this.codeName)) {
         $(this.codeName).focus();
      }

      document.querySelector('#codeStep #login-code').addEventListener('keydown', event => {
         if (event.key === 'Enter') {
            event.preventDefault();
            document.querySelector('#loginBtn').click();
         }
      });
   },

   handlePasswordSubmit: function () {
      const password = $(this.passwordName);
      const recaptchaForm = $('form-captcha-login');
      let recaptchaPlaceholder = null;
      let recaptchaKey = null;

      if (recaptchaForm) {
         recaptchaPlaceholder = document.querySelector('.js-captcha-container');
         recaptchaKey = recaptchaForm ? recaptchaForm.get('data-sitekey') : null;
      }

      const loginPromise = Recaptcha.executeInvisible(recaptchaPlaceholder, recaptchaKey, 'login')
         .then(recaptchaResponse =>
            Auth.sendLogin({
               login: this.userEmail,
               password: password.value,
               captchaResult: recaptchaResponse,
               ajax: true,
               handler: this.loginHandler.bind(this),
            })
         )
         .then(result => {
            if (!result?.loggedIn) {
               throw new SentryError('Login failed');
            }
         });

      LoadingIndicator.withPromise(loginPromise, {
         pendingMessage: _js('Checking your email and password...'),
         successMessage: _js('Login successful'),
         failureMessage: _js('Login unsuccessful'),
      });

      return false;
   },

   handleRequestCode: async function () {
      const formValues = {
         login: this.userEmail,
         captchaResult: null,
      };

      const loginCodeHandler = response => {
         if (response.emailSent) {
            this.codeSent = true;
            this.showCodeStep();
         } else {
            this.formManager.showError($('authStep'), this.getErrorMessage(response));
         }
      };

      const recaptchaForm = $('form-captcha-login');
      if (recaptchaForm) {
         const recaptchaKey = recaptchaForm.get('data-sitekey');
         const recaptchaPlaceholder = document.querySelector('.js-captcha-container');
         formValues.captchaResult = await Recaptcha.executeInvisible(
            recaptchaPlaceholder,
            recaptchaKey,
            'login_code'
         );
      }

      await Auth.sendGetLoginCode(formValues, loginCodeHandler);
   },

   handleCodeSubmit: function () {
      const code = $(this.codeName);

      const loginHandler = response => {
         Auth.clearCookies();
         StatusPanel.deactivate(/* noDelay */ true);

         if (response.loggedIn) {
            fireGlobal('login.success', response);
         } else {
            // Clear the code input on failure
            code.set('value', '');

            // Show the error message
            if (response.reason === 'password') {
               response.reason = 'invalid_code';
            }
            this.formManager.showError(code, this.getErrorMessage(response));

            // Re-focus the code input
            code.focus();

            fireGlobal('login.failure', response);
         }
      };

      const loginPromise = Auth.sendLoginWithCode(
         {
            login: this.userEmail,
            code: code.value,
         },
         loginHandler
      ).then(result => {
         if (!result?.loggedIn) {
            throw new SentryError('Login failed');
         }
      });

      LoadingIndicator.withPromise(loginPromise, {
         pendingMessage: _js('Verifying code...'),
         successMessage: _js('Login successful'),
         failureMessage: _js('Code verification failed'),
      });

      return false;
   },

   getErrorMessage: function (response) {
      // Return specific error messages based on response reason
      if (!response || !response.reason) {
         return _js('Login failed. Please try again.');
      }

      switch (response.reason) {
         case 'email': {
            return App.loginMessages.invalid_email;
         }
         case 'password': {
            return App.loginMessages.invalid_password;
         }
         case 'invalid_code': {
            return App.loginMessages.invalid_code;
         }
         case 'banned': {
            return App.loginMessages.banned;
         }
         case 'captcha': {
            return App.loginMessages.captcha;
         }
         case 'tooManyFailures': {
            const expiration = Number.parseInt(response.lockedOut, 10);
            const xMessage =
               expiration == 1
                  ? _js('Click "Forgot?" or wait one minute to try again.')
                  : _js('Click "Forgot?" or wait %1 minutes to try again.');
            return (App.loginMessages.tooManyFailures + ' ' + xMessage).replace('%1', expiration);
         }
         case 'tooManyCodeAttempts': {
            return App.loginMessages.tooManyCodeAttempts;
         }
         case 'tooManyCodeGenerations': {
            return App.loginMessages.tooManyCodeGenerations;
         }
         case 'tooManySuccesses': {
            const expiration = Number.parseInt(response.lockedOut, 10);
            const xMessage =
               expiration == 1
                  ? _js('Wait one minute to try again.')
                  : _js('Wait %1 minutes to try again.');
            return (App.loginMessages.tooManySuccesses + ' ' + xMessage).replace('%1', expiration);
         }
         case 'disabledUser': {
            return App.loginMessages.disabledUser;
         }
         case 'insecurePassword': {
            return App.loginMessages.insecurePassword;
         }
         case 'facebook': {
            return _js(
               'Please login using the "Sign in with Facebook" button instead, or remove your Facebook connection by resetting your password.'
            );
         }
         case 'OAuth2_GOOGLE': {
            return _js(
               'Please login using the "Sign in with Google" button instead, or remove your Google connection by resetting your password.'
            );
         }
         case 'adminOnlyEntrypoint': {
            return App.loginMessages.adminOnlyEntrypoint;
         }
         default: {
            return response.reason || _js('Login failed. Please try again.');
         }
      }
   },

   initializeSSO: function () {
      const googleLogin = $('googleLogin');
      if (googleLogin) {
         if (typeof google == 'undefined') {
            let po = document.createElement('script');
            po.type = 'text/javascript';
            po.async = true;
            po.src = 'https://accounts.google.com/gsi/client';
            let s = document.querySelectorAll('script')[0];
            s.parentNode.insertBefore(po, s);
         }

         const signinCallback = authResult => {
            if (authResult.credential) {
               Auth.sendLogin({
                  googleOAuthData: authResult,
                  ajax: true,
                  handler: this.loginHandler.bind(this),
               });
            } else {
               StatusPanel.deactivate(/* noDelay */ true);
               this.formManager.showError(googleLogin, App.loginMessages.OAuth2_ACCESS_TOKEN);
            }
         };

         window.onGoogleLibraryLoad = function () {
            google.accounts.id.initialize({
               client_id: App.googleOAuth2Clientid,
               callback: signinCallback,
            });

            google.accounts.id.renderButton(googleLogin, {
               width: '280px',
               text: 'signin_with',
            });
         };

         // Redundant button render for second time opening the modal
         window.google?.accounts?.id?.renderButton(googleLogin, {
            width: '280px',
            text: 'signin_with',
         });

         setupFacebookLoginButton();
      }
   },

   handleFacebookLoggedIn: function (fbResponse) {
      Auth.clearCookies();

      if (fbResponse && !fbResponse.authResponse) {
         this.formManager.showError($(this.emailName), _js('Unable to complete Facebook login.'));
         return;
      }

      Auth.sendFacebookLogin(this.loginHandler.bind(this));
   },

   loginHandler: function (response) {
      Auth.clearCookies();
      StatusPanel.deactivate(/* noDelay */ true);

      if (response.loggedIn) {
         fireGlobal('login.success', response);
         return;
      }

      let errorElement;
      switch (this.currentStep) {
         case 'auth': {
            errorElement = $(this.passwordName);
            break;
         }
         case 'code': {
            errorElement = $('codeStep');
            break;
         }
         default: {
            errorElement = $(this.emailName);
         }
      }

      // Special case for captcha errors
      if (response.reason === 'captcha') {
         this.formManager.showError(Recaptcha.container(), App.loginMessages.captcha);
      } else {
         // Use the getErrorMessage method for all other error cases
         this.formManager.showError(errorElement, this.getErrorMessage(response));
      }

      // Automatically clear error message after 1.75 seconds. Temp patch for bug where
      // the error is displayed indefinitely, but the UI jumps when focus is regained.
      setTimeout(() => {
         this.formManager.clear(errorElement);
      }, 1750);

      fireGlobal('login.failure', response);
   },

   setupView: function () {
      this.formManager.focus();
   },

   togglePassword: function () {
      let passwordInput = $('reg-password');
      if (passwordInput.get('type') === 'password') {
         passwordInput.set('type', 'text');
         $('js-password-icon').getElement('i').removeClass('fa-eye-slash').addClass('fa-eye');
      } else {
         passwordInput.set('type', 'password');
         $('js-password-icon').getElement('i').removeClass('fa-eye').addClass('fa-eye-slash');
      }
   },
});

(function () {
   let modalOptions;

   // Call outside of event listeners in case we aren't in a modal
   // (and the below events won't ever fire)
   onDomReady(initialize);

   listenGlobal('login.success', function success(response) {
      if (!modalOptions) {
         return;
      }

      if (modalOptions.close) {
         Modal.close();
      }

      if (modalOptions.onAuthorize) {
         setTimeout(modalOptions.onAuthorize.bind(modalOptions, response), Modal.animationDuration);
      }

      if (modalOptions.reload) {
         return window.location.reload();
      }
   });

   Modal.addEvent('onLoginLoad', (element, options, data) => {
      modalOptions = options;
      App.loginMessages = data.loginMessages;
      initialize();
   });

   Modal.addEvent('onLoginUnload', () => {
      teardown();
      window.LoginPanelManager = null;
      window.LoginManager = null;
   });

   function initialize() {
      if (window.LoginManager) {
         return;
      }
      window.LoginPanelManager = new LoginPanel();
      window.LoginManager = new LoginForm();
   }

   function teardown() {
      if (window.LoginPanelManager) {
         window.LoginPanelManager.destroy();
      }
   }
})();
